import BlockType110Component from '@headlines/components/block/100-110/BlockType110.vue';
import { AdminBlockType } from '@headlines/types/block/adminBlockType';
import AdminBlockTypeAttributes from '@headlines/config/block/shared/attributes/AdminBlockTypeAttributes';

const AdminBlockType110: AdminBlockType = {
  component: BlockType110Component,
  attributes: AdminBlockTypeAttributes({
    icons: true,
    author: false,
    titleComment: true,
    channel: false,
    category: false,
    lead: false,
    publishDate: false,
  }),
  articlesCount: 0,
};

export default AdminBlockType110;
